import React, { useState, useEffect } from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faTrashCan } from '@fortawesome/free-solid-svg-icons';

export const getItemColdefs = (onDelete) => [
    {
        field: "woRecvNo",
        headerName: "WO recv No",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "woRecvDate",
        headerName: "WO recv Date",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "rejectionNo",
        headerName: "Rejection no",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "pendingQty",
        headerName: "WO Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "qty",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        editable: true,
        cellClassRules: {
            'cell-error': (params) => {
                return params.value > params.data.avlStock;
            }
        },
        floatingFilter: true,
    },
    {
        field: "avlStock",
        headerName: "Avl stock",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "searchText",
        headerName: "Search Text",
        minWidth: window.innerWidth * 0.1,
        flex: 0.5,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.05,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },

    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        headerName: "",
        field: "__actions",
        width: 70,
        minWidth: 70,
        maxWidth: 70,
        sortable: false,
        filter: false,
        suppressMenu: true,
        resizable: false,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 },
        cellRenderer: (params) => {
            if (params.node.rowPinned) return '';
            return (
                <button
                    type="button"
                    title="Remove item"
                    onClick={() => onDelete && onDelete(params.data)}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#dc2626',
                        padding: '6px 8px',
                        borderRadius: '4px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = '#fee2e2'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            );
        }
    },

];

export const challanColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "refNo",
        headerName: "ref No",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "refDate",
        headerName: "ref Date",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "customer",
        headerName: "Customer",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "totalQty",
        headerName: "Total qty",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "totalWithTax",
        headerName: "Total with tax",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "finalAmt",
        headerName: "Final amt",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
];

export const vendorColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "pendingQty",
        headerName: "Pending qty",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    // {
    //     field: "quantity",
    //     headerName: "Quantity",
    //     minWidth: window.innerWidth * 0.06,
    //     flex: 0.6,
    //     filter: true,
    //     floatingFilter: true,
    // },
    {
        field: "refNo",
        headerName: "Ref No",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    // {
    //     field: "id",
    //     headerName: "Ref Id",
    //     minWidth: window.innerWidth * 0.08,
    //     flex: 0.8,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "itemId",
    //     headerName: "Ref Item Id",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "idItem",
    //     headerName: "ID item",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    {
        field: "searchText",
        headerName: "Search Text",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    }
];


export const DeliveryChallanPopup = (props) => {

    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [pinnedBottomRowDataForChallanTable, setPinnedBottomRowDataForChallanTable] = useState([]);
    const [challanGridApi, setChallanGridApi] = useState(null);
    const [challanItemDetailsGridApi, setChallanItemDetailsGridApi] = useState(null);

    useEffect(() => {
        // Skip if selection exists — let updateFooterRow handle it
        if (challanGridApi && challanGridApi.getSelectedRows()?.length > 0) return;

        const totalPendingQty = props.vendorRowData.reduce((acc, item) => acc + (item.pendingQty || 0), 0);
        const totalQty = props.vendorRowData.reduce((acc, item) => acc + (item.quantity || 0), 0);

        const woOrderQty = props.itemRowData.reduce((acc, item) => acc + (item.pendingQty || 0), 0);
        const quantity = props.itemRowData.reduce((acc, item) => acc + (item.qty || 0), 0);

        setPinnedBottomRowDataForChallanTable([{
            woRecvNo: 'Total',
            pendingQty: woOrderQty,
            qty: quantity
        }]);

        setPinnedBottomRowData([{
            itemName: 'Total',
            pendingQty: totalPendingQty,
            quantity: totalQty
        }]);
    }, [props.vendorRowData, props.open, challanGridApi]);

    // useEffect(() => {
    //     if (challanItemDetailsGridApi && challanItemDetailsGridApi.getSelectedRows()?.length > 0) return;

    //     const woOrderQty = props.itemRowData.reduce((acc, item) => acc + (item.pendingQty || 0), 0);
    //     const quantity = props.itemRowData.reduce((acc, item) => acc + (item.qty || 0), 0);

    //     setPinnedBottomRowDataForChallanTable([{
    //         woRecvNo: 'Total',
    //         pendingQty: woOrderQty,
    //         qty: quantity
    //     }]);

    // }, [props.itemRowData, challanItemDetailsGridApi]);

    const updateFooterRow = (api) => {
        const selectedRows = api.getSelectedRows();
        const allRenderedNodes = api.getRenderedNodes().filter(node => !node.rowPinned);
        const isFilterActive = api.isAnyFilterPresent();

        let rowsToSum = [];

        if (isFilterActive) {
            if (selectedRows.length > 0) {
                // Filter is active & rows are selected → show selected (filtered) rows
                const filteredData = allRenderedNodes.map(node => node.data);
                rowsToSum = selectedRows.filter(row => filteredData.includes(row));
            } else {
                // Filter is active & no rows selected → show 0
                rowsToSum = [];
            }
        } else {
            if (selectedRows.length > 0) {
                // No filter, rows selected → sum selected
                rowsToSum = selectedRows;
            } else {
                // No filter, no rows selected → sum all
                rowsToSum = allRenderedNodes.map(node => node.data);
            }
        }

        const totalPendingQty = rowsToSum.reduce((acc, item) => acc + (item.pendingQty || 0), 0);
        const totalQty = rowsToSum.reduce((acc, item) => acc + (item.quantity || 0), 0);

        const newPinnedBottomRowData = [{
            itemName: 'Total',
            pendingQty: totalPendingQty,
            quantity: totalQty
        }];

        setPinnedBottomRowData(newPinnedBottomRowData);
    };

    const updateFooterRowForChallanDetails = (gridApi) => {
        if (!gridApi) return;

        const filteredRows = [];
        gridApi.forEachNodeAfterFilter((node) => {
            if (node.data) {
                filteredRows.push(node.data);
            }
        });

        const woOrderQty = filteredRows.reduce((acc, item) => acc + (item.pendingQty || 0), 0);
        const quantity = filteredRows.reduce((acc, item) => acc + (item.qty || 0), 0);

        setPinnedBottomRowDataForChallanTable([{
            woRecvNo: 'Total',
            pendingQty: woOrderQty,
            qty: quantity
        }]);
    };

    return (
        <ModalBasic
            id="sales-invoice"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            {!props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Challan invoice details</span>
                    <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>Challan no</label>
                            <TextInput type='text'
                                id='challanNo' name='challanNo'
                                value={props.deliveryObject.challanNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'challanNo')}
                                className={props.validState?.error?.challanNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Challan date</label>
                            <TextInput type='date'
                                id='challanDate' name='challanDate'
                                value={props.deliveryObject.challanDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'challanDate')}
                                className={props.validState?.error?.challanDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>I_type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select Itype"
                                options={props.challanFromList}
                                value={props.deliveryObject.challanFrom ? props.challanFromList.find(x => x.value === props.deliveryObject.challanFrom) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "challanFrom")
                                }
                                className={props.validState?.error?.challanFrom !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Inv. type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select InvType"
                                options={props.invTypeList}
                                value={props.deliveryObject.challanType ? props.invTypeList.find(x => x.value === props.deliveryObject.challanType) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "challanType")
                                }
                                className={props.validState?.error?.challanType !== undefined ? "error" : ""}
                                isDisabled={true}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Account head</label>
                            <MultiSelectDropdown
                                drpIdentity="Select delivery"
                                options={props.accountHeadList}
                                value={props.deliveryObject.idAccountHead ? props.accountHeadList.find(x => x.value === props.deliveryObject.idAccountHead) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idAccountHead")
                                }
                                className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Select customer</label>
                            <MultiSelectDropdown
                                drpIdentity="Select customer"
                                options={props.partyAccountList}
                                value={props.deliveryObject.idVendor ? props.partyAccountList.find(x => x.value === props.deliveryObject.idVendor) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idVendor")
                                }
                                className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Delivery</label>
                            <MultiSelectDropdown
                                drpIdentity="Select delivery"
                                options={props.partyAccountList}
                                value={props.deliveryObject.idDelivery ? props.partyAccountList.find(x => x.value === props.deliveryObject.idDelivery) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idDelivery")
                                }
                                className={props.validState?.error?.idDelivery !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Order no</label>
                            <TextInput type='text'
                                id='orderNo' name='orderNo'
                                value={props.deliveryObject.orderNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'orderNo')}
                                className={props.validState?.error?.orderNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        {/* <div className='input-grp'>
                            <label>Order date</label>
                            <TextInput type='date'
                                id='orderDate' name='orderDate'
                                value={props.deliveryObject.orderDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'orderDate')}
                                className={props.validState?.error?.orderDate !== undefined ? "error" : ""}
                            />

                        </div> */}
                        <div className='input-outer grid grid-cols-6 gap-2.5 col-span-6'>
                            <div className='input-grp row-span-2 col-span-2'>
                                <label>Address</label>
                                <textarea rows={4}
                                    id='customerAddress' name='customerAddress'
                                    value={props.deliveryObject.customerAddress}
                                    onChange={(event) => props.handleChangeForWork(event, 'customerAddress')}
                                    className={`h-full ${props.validState?.error?.customerAddress !== undefined ? "error" : ""}`}
                                />
                            </div>
                            <div className='input-grp row-span-2 col-span-2'>
                                <label>Delivery address</label>
                                <textarea rows={4}
                                    id='deliveryAddress' name='deliveryAddress'
                                    value={props.deliveryObject.deliveryAddress}
                                    onChange={(event) => props.handleChangeForWork(event, 'deliveryAddress')}
                                    className={`h-full ${props.validState?.error?.deliveryAddress !== undefined ? "error" : ""}`}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Transporter</label>
                                <TextInput type='text'
                                    id='transporter' name='transporter'
                                    value={props.deliveryObject.transporter}
                                    handleChange={(event) => props.handleChangeForWork(event, 'transporter')}
                                    className={props.validState?.error?.transporter !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Vehicle no</label>
                                <TextInput type='text'
                                    id='vehicleNo' name='vehicleNo'
                                    value={props.deliveryObject.vehicleNo}
                                    handleChange={(event) => props.handleChangeForWork(event, 'vehicleNo')}
                                    className={props.validState?.error?.vehicleNo !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>P. terms</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select pterms"
                                    options={props.pTermsList}
                                    value={props.deliveryObject.idTerms ? props.pTermsList.find(x => x.value === props.deliveryObject.idTerms) : 0}
                                    onChange={(event) =>
                                        props.setFilterParameters(event, "idTerms")
                                    }
                                    className={props.validState?.error?.idTerms !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className="input-grp flex items-center gap-2.5 mt-5">
                                <button className="save-btn btns mt-auto mb-[2px] h-10" onClick={() => props.addWorkOrder()}>Add work order</button>
                            </div>
                            {props.deliveryObject.idChallanInvoice > 0 ?
                                <div className='btn-grp flex items-center gap-2.5 col-span-3'>
                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generateDeliveryChallanInvoice()}>Download Invoice
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.shareOnWhatsApp()}>Share On WhatsApp
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.sendOnEmail()}>Send Email
                                    </button>

                                </div>
                                : null}
                        </div>
                    </div>
                    <span className="text-blue text-[16px] font-semibold">Challan item details</span>
                    <div className="process-table h-[35vh] mt-5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                stopEditingWhenCellsLoseFocus={true}
                                headerHeight={65}
                                rowData={props.itemRowData}
                                columnDefs={getItemColdefs(props.removeChallanItem)}
                                onGridReady={(params) => setChallanItemDetailsGridApi(params.api)}
                                // onCellClicked={props.handleCellClickItemList}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                pinnedBottomRowData={pinnedBottomRowDataForChallanTable}
                                onCellValueChanged={(params) => {
                                    if (params.colDef.field === 'qty') {
                                        const filteredRowData = [];
                                        const allRowData = [];

                                        // Gather filtered data
                                        params.api.forEachNodeAfterFilter((node) => {
                                            if (node.data) filteredRowData.push(node.data);
                                        });

                                        // Gather all data
                                        params.api.forEachNode((node) => {
                                            if (node.data) allRowData.push(node.data);
                                        });

                                        const isFilterActive = filteredRowData.length !== allRowData.length;

                                        const dataToUse = isFilterActive ? filteredRowData : allRowData;

                                        const totalQty = dataToUse.reduce((sum, item) => sum + (item.qty || 0), 0);
                                        const totalPendingQty = dataToUse.reduce((sum, item) => sum + (item.pendingQty || 0), 0);

                                        setPinnedBottomRowDataForChallanTable([
                                            {
                                                woRecvNo: 'Total',
                                                pendingQty: totalPendingQty,
                                                qty: totalQty
                                            }
                                        ]);
                                    }
                                }}

                                onFilterChanged={() => {
                                    if (challanItemDetailsGridApi) {
                                        updateFooterRowForChallanDetails(challanItemDetailsGridApi);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            )}
            {props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Challan invoice details</span>
                    <div className="process-table h-[35vh] mt-[5px] mb-2 pb-[8px] border-b border-slate-200">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.challanRowData}
                                columnDefs={challanColdefs}
                                onCellClicked={(event) => props.handleCellClickItemList(event?.data?.woRecvNo ? event?.data?.woRecvNo : event?.data?.rejectionNo)}
                                rowSelection="multiple"
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onSelectionChanged(selectedRows);
                                }}

                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Challan item details</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.vendorRowData}
                                columnDefs={vendorColdefs}
                                onGridReady={(params) => setChallanGridApi(params.api)}
                                rowSelection="multiple"
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onItemSelectionChanged(selectedRows);
                                    updateFooterRow(event.api);
                                }}
                                pinnedBottomRowData={pinnedBottomRowData}
                                onFilterChanged={() => {
                                    if (challanGridApi) {
                                        updateFooterRow(challanGridApi);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.isAddProductsButtonLoading === true ?
                            <button className="update-btn btns flex items-center justify-center gap-2.5 w-[115px]" disabled><FontAwesomeIcon icon={faCircleNotch} spin /> Loading..</button>
                            :
                            <button className="update-btn btns w-[115px]" onClick={() => props.addProduct()}>Add products</button>
                        }
                        <button className="delete-btn btns" onClick={() => props.back()}>Back</button>
                    </div>
                </div>
            )}

        </ModalBasic>
    )
}